import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {Product} from '../../../../../../models/product';
import {environment} from '../../../../../../../../environments/environment';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-video-black-box',
  templateUrl: './video-black-box.component.html',
  styleUrls: ['./video-black-box.component.css']
})
export class VideoBlackBoxComponent implements OnInit {

  video_url;
  constructor(@Inject(MAT_DIALOG_DATA) public data: {product: Product , index: number} , private dialog: MatDialog,
  private sanitizer:DomSanitizer) { }

  hover: any;


  ngOnInit(): void {


    this.video_url = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.product.media_gallery_entries[this.data.index].extension_attributes.video_content.video_url);


  }


  onNoClick() {

    this.dialog.closeAll();

  }



}
